<template>
  <div id="user-list">
    <v-card>
      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <v-text-field
          v-model.trim="search"
          placeholder="Pesquisar"
          outlined
          hide-details
          dense
          class="user-search me-3"
          @keyup="getChatBots"
        />

        <v-spacer></v-spacer>

        <div class="d-flex align-center flex-wrap">
          <v-btn
            color="success"
            class=" px-4"
            :to="{ name: 'adicionar-bot'}"
          >
            <v-icon
              left
              size="25"
              class="mr-1"
            >
              {{ icons.mdiPlus }}
            </v-icon>
            <v-icon
              left
              size="25"
              class="mr-1"
            >
              {{ icons.mdiRobotOutline }}
            </v-icon>
            <span>Criar Bot</span>
          </v-btn>
        </div>
      </v-card-text>

      <v-col cols="12">
        <div style="min-height: 4px">
          <v-progress-linear
            v-if="loading"
            indeterminate
          />
        </div>

        <table-bots
          :items="bots"
          :headers="headers"
          @confirmar-ativacao-inativacao="getChatBots"
        />
      </v-col>
    </v-card>
  </div>
</template>

<script>
import { mdiPlus, mdiRobotOutline } from '@mdi/js'
import { ref, onMounted } from '@vue/composition-api'
import TableBots from '@/components/tables/TableBots.vue'
import ChatBotService from '@/services/modules/ChatBotService'

export default {
  components: {
    TableBots,
  },

  setup() {
    const isConfigurarClienteDialogOpen = ref(false)

    const bots = ref([])
    const loading = ref(false)
    const search = ref('')
    async function getChatBots() {
      try {
        loading.value = true
        bots.value = await ChatBotService.get()
        if (search.value) {
          bots.value = bots.value.filter(it => it.nome && it.nome.toUpperCase().includes(search.value.toUpperCase()))
        }
        loading.value = false
      } catch {
        loading.value = false
      }
    }
    onMounted(getChatBots)

    const headers = [
      { text: 'NOME', value: 'nome' },
      { text: 'DESCRIÇÃO', value: 'descricao' },
      { text: 'STATUS', value: 'statusNome' },
      {
        text: 'OPÇÔES',
        value: 'actions',
        align: 'center',
      },
    ]

    return {
      isConfigurarClienteDialogOpen,
      bots,
      loading,
      search,
      getChatBots,
      headers,
      icons: { mdiPlus, mdiRobotOutline },
    }
  },
}
</script>

  <style lang="scss">
  @import '@core/preset/preset/apps/user.scss';
  </style>
